import HomePage from "./pages/HomePage";
import ToolsPage from "./pages/ToolsPage";
import OSSCorrection from "./pages/ToolsPage/OSSCorrection";
import OSSCorrectionProjectDetails from "./pages/ToolsPage/OSSCorrection/OSSCorrectionProjectDetails";
import ContractDataConfirmations from "./pages/ToolsPage/ContractDataConfirmations";
import BusinessActions from "./pages/ToolsPage/BusinessActions.vue";

const pages = [
    {
    path: '/',
    name: 'HomePage',
    component: HomePage
  },
  {
    path: '/tools',
    component: ToolsPage,
    children: [
      {
        path: 'oss-correction',
        name: 'OSSCorrection',
        component: OSSCorrection
      },
      {
        path: 'oss-correction/:id',
        name: 'OSSCorrectionProjectDetails',
        component: OSSCorrectionProjectDetails
      },
      {
        path: 'contract-data-confirmations',
        name: 'ContractDataConfirmations',
        component: ContractDataConfirmations
      },
      {
        path: 'business-actions',
        name: 'Business Actions',
        component: BusinessActions
      }
    ]
  },
];

import {computed} from 'vue';
import { i18n } from './i18n';
const { t } = i18n.global;

const menuItems = computed(() => [
          {
            slug: 'tools',
            path: '/tools',
            name: 'ToolsPage',
            label: t('menuItems.toolsPage.linkLabel'),
            children: [
              {
                path: '/tools/oss-correction/:id',
                name: 'OSSCorrection',
                label: t('menuItems.toolsPage.children.OSSCorrection.linkLabel')
              },
              {
                path: '/tools/contract-data-confirmations',
                name: 'ContractDataConfirmations',
                label: t('menuItems.toolsPage.children.ContractDataConfirmations.linkLabel')
              },
            ]
          },
        ]);

    
export {
    pages,
    menuItems
}